import formMapper from '../../utils/formMapper';
import { NAME } from './constants';

export default formMapper(NAME, {
	channel: {
		required: false,
	},
	region: {
		required: false,
	},
	agency: {
		required: false,
	},
	manager: {
		required: false,
	},
});
